
import { Prop } from 'vue-property-decorator'
import { Vue } from 'vue-class-component'
import ModalBannerOptions from '@/interfaces/modal-banner-options'
import { useStore } from 'vuex'
import { isDeeplinkFormat, isWebsiteFormat } from '@/helpers/validator'
import liff from '@line/liff'

export default class ModalBanner extends Vue {
  @Prop() modalOptions!: ModalBannerOptions
  @Prop() redirectToWebRegister!: () => void

  private store = useStore()
  private hasBeenBlured = false
  private blurCounting = 0

  mounted() {
    this.setOpacity()
  }

  created() {
    this.handleBannerClickEvent()
  }

  handleBannerClickEvent() {
    window.onblur = () => {
      this.hasBeenBlured = true
      this.blurCounting++
    }
    window.onfocus = () => {
      if (this.hasBeenBlured) {
        this.closeLoadingLabel()
        this.hasBeenBlured = false
      }
    }
  }

  showLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', true)
    this.store.commit('app/setLoadingBarLabelHtml', this.modalOptions?.loadingBarLabel)
  }

  closeLoadingLabel() {
    this.store.commit('app/setIsLoadingHome', false)
    this.store.commit('app/setLoadingBarLabelHtml', '')
  }

  setOpacity() {
    const modalElement = document.getElementsByClassName('dummy-background-modal-banner')[0]! as HTMLElement
    setTimeout(() => { modalElement.style.opacity = '0.7' }, 10)
  }

  openNavigationBanner(url: string) {
    liff.openWindow({
      url: url
    })
  }
  
  openUrl(bannerUrl?: string) {
    if (bannerUrl) {
      if (isDeeplinkFormat(bannerUrl)) {
        this.showLoadingLabel()
        const previousBlur = this.blurCounting
        this.openNavigationBanner(bannerUrl)
        setTimeout(() => {
          /*
          the app on blur state is not updated,
          we will assume the app does not open one app
          so that we will force use to open app store instead
          */
          if (previousBlur === this.blurCounting) {
            this.openNavigationBanner(bannerUrl)
            this.closeLoadingLabel()
          }
        }, 2000)
      } else if (isWebsiteFormat(bannerUrl)) {
        this.openNavigationBanner(bannerUrl)
      }
    }
  }

  closeModal() {
    const dialogElement = document.getElementsByClassName('modal-dialog-banner')[0]! as HTMLElement
    const modalElement = document.getElementsByClassName('dummy-background-modal-banner')[0]! as HTMLElement

    dialogElement.style.bottom = '-100%'
    modalElement.style.opacity = '0'

    setTimeout(() => {
      if (this.store.state.modalBanner.isUnlinkActive) {
        this.redirectToWebRegister()
      } else {
        this.store.dispatch('modalBanner/onClose')
      }
    }, 500)
	}

  errorImage(event: any) {
    event.target.onerror = null
    this.store.dispatch('modalBanner/onClose')
  }
}
